import { useDocumentTabDataContextOptional } from 'features/knowledgeDocumentViewer/contexts/DocumentTabDataContext'
import { useKnowledgeDocumentUXContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import {
  BoundingBoxJsonItem,
  normalizeOcrPages,
} from 'features/knowledgeDocumentViewer/types/ocrViewer'
import { useMemo } from 'react'

export type OcrResultWithPage = BoundingBoxJsonItem & {
  pageNumber: number
  confirmed: boolean
}

export const useOcrResults = () => {
  const { currentDocumentQuery, assetTypeFilters } =
    useKnowledgeDocumentUXContext()
  const docTabData = useDocumentTabDataContextOptional()
  const selectedDocumentOcrEntries = docTabData?.selectedDocumentOcrEntries

  const allOcrResults = useMemo<OcrResultWithPage[]>(() => {
    const allPages = normalizeOcrPages(
      selectedDocumentOcrEntries?.[0]?.entry.data?.pages ?? []
    )

    return allPages.flatMap((page) => [
      ...page.confirmed.map((box) => ({
        ...box,
        pageNumber: page.page_number,
        confirmed: true,
      })),
      ...page.unconfirmed.map((box) => ({
        ...box,
        pageNumber: page.page_number,
        confirmed: false,
      })),
    ])
  }, [selectedDocumentOcrEntries])

  const filteredOcrResults = useMemo(() => {
    let results = allOcrResults

    if (assetTypeFilters.length > 0) {
      results = results.filter(
        (box) => box.type && assetTypeFilters.includes(box.type)
      )
    }

    if (currentDocumentQuery.trim() !== '') {
      const searchLower = currentDocumentQuery.toLowerCase()
      results = results.filter((box) =>
        box.text?.toLowerCase().includes(searchLower)
      )
    }

    return results
  }, [allOcrResults, assetTypeFilters, currentDocumentQuery])

  return {
    allOcrResults,
    filteredOcrResults,
  }
}
